import { HeadSnowflakeIcon } from './HeadSnowflakeIcon';

/**
 * author: Michael Irigoyen
 * id 9EB1D22F-C7FC-43FB-8689-40AB3FFB98E7
 * name head-snowflake
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-snowflake.svg
 * tags
 */
export const HeadFreezeIcon = HeadSnowflakeIcon;
export default HeadFreezeIcon